var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-header"},[(_vm.model.username)?_c('router-link',{staticClass:"profile-link",attrs:{"to":{
      name: 'model.username',
      params: { username: '@' + _vm.model.username },
    }}},[_c('div',{staticClass:"pic",style:({
        backgroundImage: `url('${_vm.model.public_profile_image_path}')`,
      })}),_c('div',{staticClass:"names"},[(_vm.model.name)?_c('div',{staticClass:"name"},[_vm._v("\n        "+_vm._s(_vm.model.name)+"\n        "),(_vm.model.verified)?_c('img',{staticClass:"badge-verified",attrs:{"src":"/img/verified.png","alt":"verified","title":"verified"}}):_vm._e()]):_vm._e()])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }